import { render, staticRenderFns } from "./InventoryFiles.vue?vue&type=template&id=1c8ad390&"
import script from "./InventoryFiles.vue?vue&type=script&lang=js&"
export * from "./InventoryFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports